import React from "react";
import { Tooltip } from "../Tooltip";
import InfoIcon from "../../assets/InfoIcon";
import styles from "./systemHealth.module.css";

type SectionCardProps = {
  title: string;
  icon?: React.ReactNode;
  info?: React.ReactNode;
  badge?: string;
  accent:
    | "core"
    | "eks"
    | "aws"
    | "indexing"
    | "cache"
    | "identity"
    | "sqs"
    | "cdn";
  issueCount?: number;
  children: React.ReactNode;
  className?: string;
};

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon,
  info,
  badge,
  accent,
  issueCount = 0,
  children,
  className,
}) => {
  return (
    <section
      className={`${styles.sectionCard} ${styles[`accent-${accent}`]} ${
        className || ""
      }`}
    >
      <div className={styles.sectionHeader}>
        <div className={styles.sectionTitleGroup}>
          {icon && <span className={styles.sectionIcon}>{icon}</span>}
          <h2 className={styles.sectionTitle}>{title}</h2>
          {badge && <span className={styles.sectionBadge}>{badge}</span>}
          {info && (
            <Tooltip text={info} maxWidth={260}>
              <InfoIcon className={styles.infoIcon} />
            </Tooltip>
          )}
        </div>
        {issueCount > 0 && (
          <span className={styles.sectionIssueCount}>
            {issueCount} issue{issueCount > 1 ? "s" : ""}
          </span>
        )}
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </section>
  );
};

export default SectionCard;
